import type { FaireProductEntity } from "../../entity_types/product";

export const p_bhschlby: FaireProductEntity = {
  token: "p_bhschlby",
  type: "product",
  name: "Coffee Cups Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/9d2f14ab64b52dd07a5f4ff925bd895ddad02ba1a9d52eb3d0280c89e7d87ebc/1528358864.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b4da3b7499c5028b452e42b5d4c6f12d49c16b10a71d3f1aee8517fc7e608897/1528358864.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:41.009Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
